import React from 'react';
import { logErrorToConsole } from 'src/utils/util';
import {
    StyledTabContentContianer,
    TabContent,
    TabContentFont,
    TabSelectedBorder,
} from './adminDetailTab.styled';

const AdminDetailTabList = ({ label, isTabActive, tabSwitch, id }) => {
    return (
        <>
            <StyledTabContentContianer
                id="admin-proxies-tab"
                onClick={() => {
                    try {
                        tabSwitch(id);
                    } catch (error) {
                        logErrorToConsole(error);
                    }
                }}
                isSelected={isTabActive}
                cursor={'pointer'}
            >
                <TabContent isPending={false} isBatch={false}>
                    <TabContentFont isSelected={isTabActive}>
                        {label}
                    </TabContentFont>
                </TabContent>
                <TabSelectedBorder isSelected={isTabActive} />
            </StyledTabContentContianer>
        </>
    );
};

export default AdminDetailTabList;
